import { useSyncExternalStore } from 'react';
import {
  subscribeNotifications,
  getUnreadCount,
  getCachedNotifications,
} from '../services/notifications';

export function useUnreadCount(): number {
  return useSyncExternalStore(subscribeNotifications, getUnreadCount, getUnreadCount);
}

export function useNotifications() {
  return useSyncExternalStore(subscribeNotifications, getCachedNotifications, getCachedNotifications);
}
